import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import {
  CloseDepositPayload,
  CreateDepositResponse,
  DepositDetail,
  DepositList,
  DepositSearch,
  UiOption,
} from '../interfaces/deposit.model';

@Injectable({ providedIn: 'root' })
export class DepositsService {
  constructor(private http: HttpClient) {}

  getDepositList(page: number, pageSize: number, filter: DepositSearch): Observable<DepositList> {
    return this.http.post<DepositList>('api/incassi/distinteversamenti/list', filter, {
      params: { page, pagesize: pageSize },
    });
  }

  getDepositDetail(idDeposit: string): Observable<DepositDetail | null> {
    return this.http
      .get<DepositDetail>(`api/incassi/distinteversamenti/${idDeposit}`)
      .pipe(map(detail => (!detail?.id || detail.numeroDistintaVersamenti === 0 ? null : detail)));
  }

  createDeposit(idWorksheets: string[]): Observable<string | null> {
    return this.http
      .post<CreateDepositResponse>('api/incassi/distinteversamenti/crea', {
        brogliaccioIds: idWorksheets,
      })
      .pipe(map(response => response?.idDistinta ?? null));
  }

  deleteDeposit(idDeposit: string): Observable<void> {
    return this.http.delete<void>(`api/incassi/distinteversamenti/${idDeposit}`);
  }

  verifyChecks(idDeposit: string, idChecks: string[]): Observable<void> {
    return this.http.put<void>(`api/incassi/distinteversamenti/${idDeposit}/assegni/verifica`, {
      idDistinta: idDeposit,
      assegnoIds: idChecks,
    });
  }

  verifyDeposit(idDeposit: string): Observable<void> {
    return this.http.put<void>(`api/incassi/distinteversamenti/${idDeposit}/verifica`, {});
  }

  // Irreversibile: scrive gli incassi su ERP.
  closeDeposit(idDeposit: string, payload: CloseDepositPayload): Observable<void> {
    return this.http.put<void>(`api/incassi/distinteversamenti/${idDeposit}/chiudi`, payload);
  }

  uploadReceipt(idDeposit: string, file: File): Observable<void> {
    const formData = new FormData();
    formData.append('file', file, file.name);

    return this.http.post<void>(`api/incassi/allegati/distinte/${idDeposit}`, formData);
  }

  downloadReceipt(idAttachment: string): Observable<Blob> {
    return this.http.get(`api/incassi/allegati/distinte/documento/${idAttachment}`, {
      responseType: 'blob',
    });
  }

  downloadDepositPdf(idDeposit: string): Observable<Blob> {
    return this.http.get(`api/incassi/stampe/distintaVersamenti/${idDeposit}`, {
      responseType: 'blob',
    });
  }

  getBancheVersamento(): Observable<UiOption[]> {
    return this.http.get<UiOption[]>('api/incassi/lookup/bancheVersamento');
  }
}
